// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.extra-role[data-v-5987ce25] {\n  margin-right: 10px;\n  padding-left: 20px;\n  height: 15px;\n  display: inline-block;\n  line-height: 15px;\n  background-repeat: no-repeat;\n  background-position: 0 0;\n  font-size: 12px;\n  vertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
